import { appConstants } from "constants/appConstants";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { promotionService } from "services/promotionService";
import { userService } from "services/userService";
import { venueService } from "services/venueService";
import { RootState } from "store";
import { errorAlert } from "utils/alertHandler";
import { convertHoursToDays, convertHoursToHourMinutes } from "utils/convertHoursToDisplayString";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

export default function useProfilePersonalInfo() {
  const { user } = useSelector((state: RootState) => state.auth);

  const [totalBookingHours, setTotalBookingHours] = useState<String | null>(null);

  const [pointInfo, setPointInfo] = useState<any>();
  const [pointBalance, setPointBalance] = useState<number | null>(null);
  const [pointHistory, setPointHistory] = useState<Array<any> | null>(null);

  const [membership, setMembership] = useState<any>();
  const [vouchers, setVouchers] = useState<any[] | null>(null);

  const { language } = useSelector((state: RootState) => state.lang);

  useEffect(() => {
    (async function () {
      try {
        const res = await userService.getUserPoints();

        const organizationPoint = await promotionService.getOrganizationPoint();

        const membershipResult = await userService.getUserMembership();

        const voucherResult = await userService.getUserVouchers();

        const userBookings = await venueService.getVenueBookingsByVenueIdAndUserId(Number(REACT_APP_DEFAULT_VENUE_ID), {
          filter: `[vb.status:eq:1]`,
          limit: 999,
        });

        if (voucherResult) {
          const availableVouchers = voucherResult
            .filter((voucher: any) => voucher.is_applied === 0)
            .filter((voucher: any) => (voucher.is_never_expire == 0 && moment(voucher.expired_at).isAfter(moment())) || voucher?.is_never_expire == 1);

          console.log("voucherResult : ", voucherResult);

          setVouchers(voucherResult);
        }

        if (membershipResult) {
          setMembership({
            name: language === appConstants.LANGUAGE.DEFAULT_LANGUAGE ? membershipResult?.membership_name_tc : membershipResult?.membership_name_en,
            is_enable_venue_discount: membershipResult?.is_enable_venue_discount,
            discount: `- ${membershipResult?.venue_booking_discount_type == 1 ? "HKD$" : ""} ${membershipResult?.venue_booking_discount_value} ${
              membershipResult?.venue_booking_discount_type == 0 ? "%" : ""
            }`,
          });
        }

        if (organizationPoint) {
          setPointInfo(organizationPoint);
        }

        if (res) {
          setPointHistory(res?.list);
          setPointBalance(res?.total);
        }

        if (userBookings && userBookings.length > 0) {
          const totalBookingHours = userBookings.reduce((prev: any, current: any) => {
            const start = moment(current.start_date_time);
            const end = moment(current.end_date_time);
            const duration = moment.duration(start.diff(end));
            const hours = Math.abs(duration.asHours());

            return (prev += hours);
          }, 0);

          setTotalBookingHours(convertHoursToHourMinutes(totalBookingHours));
        }
      } catch (error: any) {
        errorAlert(error?.message);
      }
    })();
  }, []);

  function getValidVouchers() {
    if (vouchers) {
      return vouchers
        ?.filter((voucher: any) => voucher.is_applied === 0)
        .filter((voucher: any) => (voucher.is_never_expire == 0 && moment(voucher.expired_at).isAfter(moment())) || voucher?.is_never_expire == 1)?.length;
    }
    return 0;
  }

  return {
    user,
    membership,
    vouchers,
    validVouchers: getValidVouchers(),
    totalBookingHours,
    pointInfo,
    pointBalance,
    pointHistory,
  };
}
